import React, { useEffect, useRef, useState } from 'react';
import { useViewlogies } from 'context';
import './resources.scss';
import EmbeddedVideoPlayer from 'components/VideoPlayer';

const VideoInterface = ({ videoUrl, color, title, description, link, linkText }) => {
    const { isMobile } = useViewlogies();
    const [hover, setHover] = useState(false);

    const wrapperRef = useRef(null);
    const [maxWidth, setMaxWidth] = useState('100%');

    const updateWidth = () => {
        if (!wrapperRef.current) return;

        const maxHeight = window.innerHeight;
        const aspectRatio =
            maxHeight < 500 ? 16 / 17 : maxHeight < 750 ? 13 / 17 : maxHeight < 1400 ? 12 / 17 : 11 / 17;
        console.log('aspectRatio');
        console.log(aspectRatio);

        const calculatedMaxWidth = maxHeight / aspectRatio;
        setMaxWidth(`${Math.min(window.innerWidth, calculatedMaxWidth)}px`);
    };

    useEffect(() => {
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => window.removeEventListener('resize', updateWidth);
    }, []);

    return (
        <section className="resources-card" ref={wrapperRef} style={!isMobile ? { maxWidth: maxWidth } : {}}>
            {isMobile && <h2 className="video-description-title">{title}</h2>}
            <div className="resources-video-wrapper">
                <EmbeddedVideoPlayer url={videoUrl} />
            </div>
            <div className="resources-card-text">
                <div className="video-info">
                    {!isMobile && <h2 className="video-description-title">{title}</h2>}
                    <p className="video-description">{description}</p>
                </div>
                <div className="resources-link-container">
                    <a
                        className="viewlogies-button resources-link"
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        style={{
                            color: hover ? color : '#fff',
                            border: `2px solid ${color}`,
                            backgroundColor: hover ? 'unset' : color,
                        }}
                    >
                        {linkText}
                    </a>
                </div>
            </div>
        </section>
    );
};

// const VideoInterface = ({ videoSrc, color, title, description, link, linkText }) => {
//     const [hover, setHover] = useState(false);

//     return (
//         <section className="resources-card">
//             {/* <img src={videoSrc} alt="" /> */}
//             {/* VIDEO HERE */}
//             <div className="resources-card-text">
//                 <h2>{title}</h2>
//                 <p>{description}</p>
//                 <div className="resources-link-container">
//                     <a
//                         className="viewlogies-button resources-link"
//                         href={link}
//                         target="_blank"
//                         rel="noopen noreferrer"
//                         onMouseEnter={() => setHover(true)}
//                         onMouseLeave={() => setHover(false)}
//                         style={{
//                             color: hover ? color : '#fff',
//                             border: `2px solid ${color}`,
//                             backgroundColor: hover ? 'unset' : color,
//                         }}
//                     >
//                         {linkText}
//                     </a>
//                 </div>
//             </div>
//         </section>
//     );
// };

export default VideoInterface;
